export const environment = {
  production: true,
  APIURL: 'https://e4-eztrack-api.azurewebsites.net/api/v1/',
  APIURLV2:'https://e4-eztrack-api.azurewebsites.net/api/v2/',
  APIV3:'https://as-trackassured-prod-eus-api.azurewebsites.net/api/v1/',
  AUTO_REFRESH_TIME_OUT: 300000, //5mint
  AUTO_REFRESH_TIME_OUT_ezSettings: 900000, //15mint
};
